import { merge } from 'lodash'
import { StateCreator } from 'zustand'

type TScenarioDefinition = {
  newActions: string[]
}

type TCreateScenarioParams = {
  scenario: TScenarioDefinition
}

export type TCreateScenarioState = TCreateScenarioParams & {
  setScenario(scenario: TScenarioDefinition): void
}

export const initialState: TScenarioDefinition = { newActions: [] }

const createScenarioSlice: StateCreator<
  TCreateScenarioState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  scenario: initialState,

  setScenario: (scenario) =>
    set(
      (state) => ({
        scenario: merge(state.scenario, scenario),
      }),
      undefined,
      {
        type: 'setScenario',
        scenario,
      },
    ),
})

export default createScenarioSlice
